import type { IconNames } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';

import QueueFromPayload from 'components/powerFlowShared/components/queueFromPayload';
import {
  FlowNodeTypes,
  OptionT,
} from 'components/powerFlowShared/components/types';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
} from 'fable/flowEditor';

import ActionModal from '../../containers/modals/queue';
import { PowerChatFlowExtraDataT } from '../PowerChatFlow';

export type FlowChatNodeQueuePayloadT = {
  queue: null | OptionT;
  queue_timeout?: {
    timeout_in_seconds: number;
    timeout_node_id: null | string;
  };
  welcome_message?: null | string;
};

type FlowChatNodeQueueTypeT = FlowNodeTypes.QUEUE;
export type FlowChatNodeQueueT = NodeT<
  FlowChatNodeQueueTypeT,
  FlowChatNodeQueuePayloadT
>;

export class QueueNode extends NodeTypeComponent<
  FlowChatNodeQueueT,
  PowerChatFlowExtraDataT
>() {
  static icon: IconNames = 'users';
  static label = 'Queue';
  static color = flowNodeColor.green;
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.QUEUE };
  static updateConnection = (
    node: FlowChatNodeQueueT,
    _port: InternalPortT,
    newConnection: string,
  ): FlowChatNodeQueueT => {
    const payload: FlowChatNodeQueuePayloadT = { ...node.payload };

    if (payload?.queue_timeout) {
      payload.queue_timeout = {
        ...payload.queue_timeout,
        timeout_node_id: newConnection,
      };
    }

    return { ...node, payload };
  };

  @boundMethod
  triggerEdit(): void {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  }

  render() {
    return (
      <FlowNode
        color={QueueNode.color}
        icon={QueueNode.icon}
        label={QueueNode.label}
        text={
          <QueueFromPayload
            node={this.props.node}
            extraData={this.props.extraData}
          />
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
